<template>
  <el-row>
    <el-col :span="24">
      <el-card v-loading="loading">
        <div slot="header" class="flex-space-between">
          <span class="title">Community</span>
          <div>
            <el-tooltip content="Insert" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="insert()"
              ></el-button>
            </el-tooltip>
            <Dialog />
          </div>
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/community/Table'
import Dialog from '../components/community/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  computed: {
    ...mapState('communityCarousel', ['loading'])
  },

  methods: {
    ...mapMutations('communityCarousel', ['setDialog', 'setSelectedCommunity']),
    initialCommunity() {
      return {
        id: null,
        title: null,
        role: null,
        name: null,
        quote: null,
        post_link: null,
        position: null,
        image_url: null
      }
    },
    insert() {
      this.setDialog(true)
      this.setSelectedCommunity(this.initialCommunity())
    }
  }
}
</script>
